const ATTRIBUTE_KEY = 'Pet Name';
const INPUT_SELECTOR = '[data-pet-name-input]';
const SAVE_DELAY = 500;

/** @type {number | undefined} */
let timer;
/** @type {string | null} */
let dirtyValue = null;
/** @type {Promise<void> | null} */
let inFlight = null;

/** @param {'saving' | 'saved' | 'error' | ''} state */
function setStatus(state) {
  const el = document.querySelector('[data-pet-name-status]');
  if (!(el instanceof HTMLElement)) return;

  const labels = { saving: 'Saving…', saved: 'Saved ✓', error: 'Not saved', '': '' };
  el.dataset.state = state;
  el.textContent = labels[state];

  if (state === 'saved') {
    setTimeout(() => {
      if (el.dataset.state === 'saved') setStatus('');
    }, 1800);
  }
}

/** @param {string} value */
async function save(value) {
  setStatus('saving');
  try {
    const root = window.Shopify?.routes?.root ?? '/';
    const response = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      // An empty string removes the attribute from the cart
      body: JSON.stringify({ attributes: { [ATTRIBUTE_KEY]: value } }),
    });
    if (!response.ok) throw new Error('Cart update failed');
    setStatus('saved');
  } catch (error) {
    console.error(error);
    setStatus('error');
  }
}

async function flush() {
  clearTimeout(timer);
  if (dirtyValue !== null) {
    const value = dirtyValue;
    dirtyValue = null;
    inFlight = save(value);
  }
  if (inFlight) await inFlight;
  inFlight = null;
}

document.addEventListener('input', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || !input.matches(INPUT_SELECTOR)) return;

  dirtyValue = input.value.trim();
  clearTimeout(timer);
  timer = setTimeout(flush, SAVE_DELAY);
});

document.addEventListener('change', (event) => {
  if (event.target instanceof HTMLElement && event.target.matches(INPUT_SELECTOR)) flush();
});

// Make sure a pending name is saved before the customer goes to checkout
document.addEventListener(
  'click',
  async (event) => {
    const target = event.target instanceof Element ? event.target.closest('[name="checkout"]') : null;
    if (!target || (dirtyValue === null && !inFlight)) return;

    event.preventDefault();
    event.stopPropagation();
    await flush();
    /** @type {HTMLElement} */ (target).click();
  },
  true
);